module.exports = __webpack_public_path__ + "img/list20231114002.d08cfde9.png";